export const UPGRADE_DISMISSED_KEY = 'upgrade_prompt_dismissed';
